import React from 'react'
import injectJss from 'react-jss'
import PropTypes from 'prop-types'
import compose from 'recompose/compose'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import { connect } from 'react-redux'

const style = {
    imgPreview: {
        display: 'flex',
        width: 'auto',
        height: 'auto',
        margin: 'auto',
        maxWidth: '100%',
        maxHeight: ({ isLandscape, isMobile }) => (isLandscape && isMobile ? '100vh' : '515px'),
    },
}

const PhotoViewer = ({ src, classes }) => <img src={src} className={classes.imgPreview} />

PhotoViewer.propTypes = {
    src: PropTypes.string,
    maxWidth: PropTypes.number,
    maxHeight: PropTypes.number,
}

export default compose(
    connect(
        mapSelectorsToProps(['isLandscape']),
        null
    ),
    injectJss(style)
)(PhotoViewer)
